import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import SideMenuItem from "component/sidemenu/SideMenuItem";
import routes from "routes/routes";
import getToBeSigned from "api/toBeSigned/getToBeSigned";
import SideMenuSection from "component/sidemenu/SideMenuSection";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, DialogActions } from "@mui/material";
import t from "module/translations";

const ToBeSignedMenuSection: React.FC = () => {
  const history = useHistory();
  const [count, setCount] = useState<number | undefined>();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    async function getToBeSignedCount() {
      const fromApi = await getToBeSigned();
      setCount(fromApi.count);
      setIsOpen(true);
    }
    getToBeSignedCount();
  }, []);

  const onCancel = () => {
    setIsOpen(false);
  };

  const handleView = () => {
    setIsOpen(false);
    history.push(routes.toBeSigned.path);
  };

  return (
    <>
      <SideMenuSection>
        <SideMenuItem
          {...{
            title: routes.toBeSigned.title || "",
            path: routes.toBeSigned.path,
            key: routes.toBeSigned.path,
            badgeContent: count || undefined,
          }}
        />
      </SideMenuSection>
      <Dialog maxWidth="md" open={isOpen && !!count && count > 0} keepMounted>
        <DialogTitle>{t.toBeSigned.modalTitleText}</DialogTitle>
        <DialogActions>
          <Button autoFocus onClick={onCancel} color="primary">
            {t.toBeSigned.cancelText}
          </Button>
          <Button onClick={handleView} color="primary">
            {t.toBeSigned.viewText}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default React.memo(ToBeSignedMenuSection);
